module.exports = __webpack_public_path__ + "static/media/blockchain1.668ba18b.svg";